import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#itemshippingdetails"
        }}>{`ItemShippingDetails`}</a>{` for a custom line item.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setCustomLineItemShippingDetails"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`customLineItemId`}</inlineCode>{` - String`}<br parentName="li"></br>
          {`The ID of the custom line item that is to be updated.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`shippingDetails`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#itemshippingdetailsdraft"
          }}>{`ItemShippingDetailsDraft`}</a>{` - Optional`}<br parentName="li"></br>
          {`The new shipping details for the custom line item.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      